import React from 'react';
import { useFormContext } from 'react-hook-form';
import I18n from '@/modules/i18n';
import Text from '@/components/ui/Text';
import { NotifyStudentsClassroom } from './NotifyStudentsModal.utils';
import ClassroomCollapsibleSection from './ClassroomCollapsibleSection';

interface NotifyStudentsFormProps {
  alreadyJoinedStudentIds: number[];
  classrooms: NotifyStudentsClassroom[];
}

const NotifyStudentsForm = ({ alreadyJoinedStudentIds, classrooms }: NotifyStudentsFormProps) => {
  const { setValue, watch } = useFormContext();
  const allValues = watch();

  const eligibleStudents = (classroom: NotifyStudentsClassroom) => (
    classroom.students.filter(s => !alreadyJoinedStudentIds.includes(s.id))
  );
  const totalEligibleStudents = classrooms.reduce((acc, cur) => acc + eligibleStudents(cur).length, 0);
  const allChecked = totalEligibleStudents > 0 && Object.values(allValues).flat().length === totalEligibleStudents;

  const handleChange = () => {
    if (allChecked) {
      classrooms.forEach(classroom => setValue(classroom.id.toString(), []));
    } else {
      classrooms.forEach(classroom => (
        setValue(classroom.id.toString(), eligibleStudents(classroom).map(s => s.id.toString()))
      ));
    }
  };

  return (
    <div className="tw-pb-4 tw-flex tw-flex-col tw-flex-1 tw-min-h-0">
      <label className="tw-flex tw-items-center tw-justify-end tw-gap-2 tw-pb-2 tw-cursor-pointer">
        <input
          checked={allChecked}
          type="checkbox"
          onChange={handleChange}
        />
        <Text size="sm">{I18n.t('select_deselect_all')}</Text>
      </label>
      <div className="tw-flex-1 tw-min-h-0 tw-overflow-y-auto">
        {classrooms.map(classroom => (
          <ClassroomCollapsibleSection
            key={classroom.id}
            alreadyJoinedStudentIds={alreadyJoinedStudentIds}
            classroom={classroom}
          />
        ))}
      </div>
    </div>
  );
};

export default NotifyStudentsForm;
